<template>
  <DxPopup @hidden="onHidden" :visible="showPop2" :show-close-button="true" :show-title="true" :title="'Files attachment Control'" height="400px" width="1200px" container=".v-application">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-vertical :headerTitle="'Files attachment (Before) Control'" >
          <template v-slot:body>
            <v-layout column >
              <v-row no-gutters>
                <v-col cols="12">
                  <DxDataGrid id="v80o1020Pop" 
                    class="v80o1020Pop"
                    :height="220"
                    :ref="v80o1020PopRef"
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="false"
                    :column-hiding-enabled="false" 
                    @cellPrepared="cellPrepared"
                  >
                    <DxColumn data-field="id" caption="No" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="fileNo" caption="File No" width="30%" data-type="string" alignment="center" cell-template="fileNoTemplate" :allow-editing="false"/>
                    <DxColumn data-field="fileName" caption="File Name" width="35%" data-type="string" alignment="center" cell-template="fileNameTemplate" :allow-editing="false"/>
                    <DxColumn data-field="reason" caption="Reason" width="15%" data-type="string" alignment="center"/>

                    <template #fileNoTemplate="{ data }">
                      <v-btn x-small elevation="0" color="transparent" class="btnClick" @click="fileOpen(data)" >
                        {{ data.text }}
                      </v-btn>
                    </template>
                    <template #fileNameTemplate="{ data }">
                      <v-btn x-small elevation="0" color="transparent" class="btnClick" @click="fileOpen(data)" >
                        {{ data.text }}
                      </v-btn>
                    </template>


                    <DxPaging :enabled="false" :page-size="30" />
                    <DxPager :visible="false" />
                  </DxDataGrid>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <span class="pa-3 pr-0">File : </span>
                <v-col cols="2">
                  <v-file-input label="File input" class="pa-0" type="file" v-model="fileName"></v-file-input>
                </v-col>
                <span class="pa-3 pr-0">Reason : </span>
                <v-col cols="2" class="pa-2">
                  <v-text-field
                    dense 
                    outlined 
                    hide-details="auto"
                    v-model="remark"
                    @keyup="uppercase"
                  />
                </v-col>
                <v-col cols="full" class="pt-2 pl-4">
                  <v-btn small height="30" class="pa-2 btn" outlined @click="goUpload">
                    <v-icon small class="pt-0" left>$folder</v-icon>Upload file
                  </v-btn>
                  <v-btn small height="30" class="pa-2 btn" outlined @click="goSave">
                    <v-icon small class="pt-0" left>$save</v-icon>Update file
                  </v-btn>
                  <v-btn small height="30" class="pa-2 btn" outlined @click="goDelete">
                    <v-icon small class="pt-0" left color="red">$delete</v-icon>
                    <span style="color: red;">Delete file</span>
                  </v-btn>
                  <v-btn small height="30" class="pa-2 btn" outlined @click="btnClose">
                    <v-icon small class="pt-0" left>$close</v-icon>Close
                  </v-btn>
                </v-col>
              </v-row>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </DxPopup>
</template>

<script>
import { DxPopup } from 'devextreme-vue/popup';
import { DxDataGrid, DxEditing, DxColumn , DxPager } from 'devextreme-vue/data-grid'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import { v80oFileList , getFileNo , v80o1020UploadFile , v80o1020UpdateReason ,v80o1020DelFile } from '@/api/view/hip/8/v80o1020Popup.js'
import { ftpDownload} from '@/api/view/hip/common/common.js'
import notify from 'devextreme/ui/notify' // message
import { getCurrentDate } from '@/utils/common.js'

export default {
  name: 'v80o1020Pop',
  mixins: [baseview, BaseDataGrid],
  components: {
    DxPopup,
    ICardVertical,
    iCardTop,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPager
  },
  props: {
    showPop2: {
      type: Boolean,
      default() {
        return false
      }
    },
    popupData: {
      type: Array,
      default() {
        return
      }
    },
  },
  data() {
    return {
      v80o1020PopRef: 'v80o1020PopRef',
      gridMainList: [],

      fileName: null,
      remark: '',
      uploadData: [],
      fileNo: '',
      thisYear: getCurrentDate(1)
    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.v80o1020PopRef)
    },
  },

  watch: {
    'showPop2': {
      handler(value, oldValue) {
        if(value) {
          
          this.fileName = null
          this.remark = ''
          this.uploadData = []
          this.fileNo = ''
          this.thisYear = getCurrentDate(1)
          
          this.doSearchMain()
        }
      },
      immediate: true
    }

  },

  mounted(){
    
    this.gridMainInstance.option('defaultPaging', false)
  },
  methods: {
    onHidden(e) {
      this.$emit('update:showPop2', false)
      this.gridMainList = []
    },
    isSave() {
      this.$emit('fileSave' , this.popupData)
    },
    async doSearchMain(){
      this.openLoading('searching')
      let params = { 
        inspAct: this.popupData.inspAct , 
        reqDate: this.popupData.reqDate , 
        respCd: this.popupData.respCd ,
        revNo: this.popupData.revNo ,
        shipNo: this.popupData.shipNo ,
        makerCd: this.popupData.makerCd 
      } 
      await v80oFileList(params).then(res => {
        if(res.list.length){
          let cnt = 1
          res.list.forEach(e => {
            e.id = cnt++
          });
        }
        this.gridMainList = res.list

      }).finally(() => {
        this.endLoading()
      })
    },
    goUpload(){
      // if(this.popupData.reqDate.substring(0,4) < this.thisYear.substring(0,4)){
      //   this.vToastify(this.$t('Only files for this year are saved.'), 'warn')
      //   return
      // }
      if(!this.fileName){
        this.vToastify(this.$t('Select upload file.'), 'warn')
        return
      }
      //ls_file_kind
      let testfile = this.fileName.name.substring(this.fileName.name.lastIndexOf('.') + 1)
      let fileName = this.fileName.name

      let params = {
        // respCd: this.popupData.respCd,
        inspAct: this.popupData.inspAct,
        shipNo: this.popupData.shipNo,
        makerCd: this.popupData.makerCd,
        year: this.thisYear.substring(0,4),
      }
      getFileNo(params).then(res => {
        this.fileNo = res.list[0].fileNo
      }).finally(() => {
        const formData = new FormData()
        this.uploadData = {
          reqDate: this.popupData.reqDate,
          makerCd: this.popupData.makerCd,
          shipNo: this.popupData.shipNo,
          inspAct: this.popupData.inspAct,
          revNo: this.popupData.revNo,
          fileName: this.fileName.name,
          fileKind: testfile,
          filePath: 'attachfile/epms/files/' + this.fileNo + '.' + testfile,
          userId: this.popupData.makerCd,
          div: 'S',
          remark: this.remark,
          fileNo: this.fileNo,
        }
        formData.append('files', this.fileName)
        formData.append('masterData', JSON.stringify(this.uploadData))

        try {
          this.openLoading('searching')
          this.vToastifyPrompt(
            this.$t('Do you want to attach this file?'),
            'info',
              current => {
                v80o1020UploadFile(formData).then(res => {
                  if(res.body === 'Y'){
                    notify(this.$t('The file Upload is completed.'), 'success', 3000)
                  } else {
                    this.vToastify(this.$t('An error has occured while uploading file...' + "<br>" + res.body), 'warn')
                  }
                  this.isSave()
                })
                .catch(error => {
                  this.vToastify(error, 'warn')
                })
                .finally(() => {
                  this.fileName = null
                  this.remark = ''
                  this.doSearchMain()
                })
              },
            null,
            true
          )
        } finally{
          this.endLoading()
        }
      })
    },
    async goSave(){
      if(this.gridMainList.length > 0){
        await this.gridMainInstance.saveEditData()
        var selectedMainRows = await this.gridMainInstance.getSelectedRowsData()

        if(!selectedMainRows.length){
          this.vToastify(this.$t('Data is not selected.'), 'warn')
          return
        }

        selectedMainRows.forEach(e => {
          e.shipNo = this.popupData.shipNo
          e.inspAct = this.popupData.inspAct
          e.custCd = this.popupData.makerCd
          e.reqDate = this.popupData.reqDate
          e.revNo = this.popupData.revNo
          e.userId = this.popupData.makerCd
          e.reason = e.reason.toUpperCase()
        });

        try {
          this.openLoading('searching')
          this.vToastifyPrompt(
            this.$t('Do you want to Save the data?'),
            'info',
              current => {
                v80o1020UpdateReason(selectedMainRows).then(res => {
                  if(res.body === 'Y'){
                    notify(this.$t('The Reason Update is complted.'), 'success', 3000)
                  } else {
                    this.vToastify(this.$t('An error has been occured while update data :' + "<br>" + res.body), 'warn')
                  }
                  this.isSave()
                })
                .catch(error => {
                  this.vToastify(error, 'warn')
                })
                .finally(() => {
                  this.gridMainInstance.clearSelection()
                  this.doSearchMain()
                })
              },
            null,
            true
          )
        }finally {
          this.endLoading()
        }
      }
    },
    async goDelete(){
      if(this.gridMainList.length > 0){
        await this.gridMainInstance.saveEditData()
        var selectedMainRows = await this.gridMainInstance.getSelectedRowsData()

        if(!selectedMainRows.length){
          this.vToastify(this.$t('Data is not selected.'), 'warn')
          return
        }

        selectedMainRows.forEach(e => {
          e.shipNo = this.popupData.shipNo
          e.inspAct = this.popupData.inspAct
          e.custCd = this.popupData.makerCd
          e.reqDate = this.popupData.reqDate
          e.revNo = this.popupData.revNo
        });

        try {
          this.openLoading('searching')
          this.vToastifyPrompt(
            this.$t('Do you want to delete this file?'),
            'info',
              current => {
                this.openLoading('searching')
                v80o1020DelFile(selectedMainRows).then(res => {
                  if(res.body === 'Y'){
                    notify(this.$t('The file Deleting is completed.'), 'success', 3000)
                  } else {
                    this.vToastify(this.$t('An error has been occured while deleting data.'), 'warn')
                  }
                  this.isSave()
                })
                .catch(error => {
                  this.vToastify(error, 'warn')
                })
                .finally(() => {
                  this.gridMainInstance.clearSelection()
                  this.doSearchMain()
                })
              },
            null,
            true
          )
        } finally {
          this.endLoading()
        }
      }
    },
    btnClose(){
      this.isSave()
      this.$emit('update:showPop2', false)
    },
    cellPrepared(e){
      if(e.rowType === 'data'){
        if(e.column.dataField === 'reason'){
          e.cellElement.classList.add('uppercase')
        }
      }
    },
    fileOpen(e){

      let fileType = e.values[3].substring(e.values[3].lastIndexOf('.') + 1)      
      let filePath = 'attachfile/epms/files/' + e.values[2] + '.' + fileType
      
      this.openLoading('searching')
      ftpDownload(filePath, e.values[2])
      .finally(() => {
        this.endLoading()
      })
    },
    uppercase(){
      if(!this.porNo){
        this.remark = this.remark.toUpperCase()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.btn {
  background-color: rgb(135,155,119);
  margin-right: 2px;
  font-size: 10pt;
  color: white;
}
.btnClick{
  padding: 0;
  font-size: 12px;
}
.btnClick:hover{
  color: #4980BC;
}
::v-deep .uppercase {
  text-transform: uppercase !important;
}

// ::v-deep .dx-datagrid {
//   .editable-cell:not(.cuppercase) {
//     text-transform: uppercase !important;
//   }
// }
</style>